import seriesData from "../../seatComponents/series";
import upholsteredData from "../../seatComponents/upholstered";

/**
 * Validates if a series code exists
 * @param {string} seriesCode - The series code to validate
 * @returns {boolean} True if the series exists
 */
export const isValidSeries = (seriesCode) => {
  if (!seriesCode) return false;
  return seriesData.some((series) => series.code === seriesCode);
};

/**
 * Gets the style code for a given series
 * @param {string} seriesCode - The series code
 * @returns {string|null} The style code or null if not found
 */
export const getStyleFromSeries = (seriesCode) => {
  const series = seriesData.find((s) => s.code === seriesCode);
  if (!series || !series.style || series.style.length === 0) return null;
  return series.style[0]; // Return the first style
};

/**
 * Gets the upholstered code for a given series
 * @param {string} seriesCode - The series code
 * @returns {string|null} The upholstered code or null if not found
 */
export const getUpholsteredFromSeries = (seriesCode) => {
  // Check if the series exists in upholstered data
  const upholstered = upholsteredData.find((u) => u.series && u.series.includes(seriesCode));
  return upholstered ? upholstered.code : null;
};

/**
 * Gets all derived selections from a series code
 * @param {string} seriesCode - The series code
 * @returns {object|null} Object containing series, style, and upholstered or null if invalid
 */
export const getSelectionsFromSeries = (seriesCode) => {
  if (!isValidSeries(seriesCode)) return null;

  const style = getStyleFromSeries(seriesCode);
  const upholstered = getUpholsteredFromSeries(seriesCode);

  if (!style || !upholstered) return null;

  return {
    series: seriesCode,
    style,
    upholstered,
  };
};
